module.exports = __webpack_public_path__ + "static/media/Rubik-Italic.275d84ab.ttf";